import { render, staticRenderFns } from "./RankingsTodaysMatches.vue?vue&type=template&id=57b5d20e&scoped=true"
import script from "./RankingsTodaysMatches.vue?vue&type=script&lang=js"
export * from "./RankingsTodaysMatches.vue?vue&type=script&lang=js"
import style0 from "./RankingsTodaysMatches.vue?vue&type=style&index=0&id=57b5d20e&prod&lang=scss"
import style1 from "./RankingsTodaysMatches.vue?vue&type=style&index=1&id=57b5d20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5d20e",
  null
  
)

export default component.exports